import React, { Component } from "react";
import Axios from "axios";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit, faTrashAlt } from "@fortawesome/free-solid-svg-icons";
import Constant from "../Constant";
import { getAccessToken } from "../../hooks/AccessToken";

const INPUT_TYPES = {
  TEXT: "text",
  RADIO: "radio",
  CHECKBOX: "checkbox",
  SELECT: "select",
  IMAGE: "image",
};

class FormQuestions extends Component {
  state = {
    questions: [],
    newQuestion: {
      questionText: "",
      inputType: INPUT_TYPES.TEXT,
      options: [],
      isRequired: false,
      allowOther: false,
      imageUrl: "",
    },
    editingQuestion: null,
    loading: true,
    error: null,
    isAdding: false,
    uploadingImage: false,
  };

  fetchQuestions = async () => {
    const { id } = this.props.match.params;
    const token = getAccessToken();
    try {
      const response = await Axios.get(
        `${Constant.apiBasePath}registration-forms/${id}`,
        {
          headers: { token },
        }
      );
      console.log("Form Qs", response.data.data.questions);
      if (response.data.message === "Form retrieved successfully") {
        this.setState({
          questions: response.data.data.questions,
          loading: false,
        });
      } else {
        this.setState({ error: response.data.message, loading: false });
      }
    } catch (err) {
      console.error("Error fetching form questions:", err);
      this.setState({
        error: "Failed to fetch questions. Please try again.",
        loading: false,
      });
    }
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;
    const currentQuestion = this.state.editingQuestion
      ? "editingQuestion"
      : "newQuestion";
    this.setState((prevState) => ({
      [currentQuestion]: { ...prevState[currentQuestion], [name]: value },
    }));
  };

  handleOptionChange = (index, value, isEditing = false) => {
    const currentQuestion = isEditing ? "editingQuestion" : "newQuestion";
    this.setState((prevState) => {
      const options = [...prevState[currentQuestion].options];
      options[index] = value;
      return {
        [currentQuestion]: { ...prevState[currentQuestion], options },
      };
    });
  };

  addOption = (isEditing = false) => {
    const currentQuestion = isEditing ? "editingQuestion" : "newQuestion";
    this.setState((prevState) => ({
      [currentQuestion]: {
        ...prevState[currentQuestion],
        options: [...prevState[currentQuestion].options, ""],
      },
    }));
  };

  removeOption = (index, isEditing = false) => {
    const currentQuestion = isEditing ? "editingQuestion" : "newQuestion";
    this.setState((prevState) => {
      const options = prevState[currentQuestion].options.filter(
        (_, i) => i !== index
      );
      return {
        [currentQuestion]: { ...prevState[currentQuestion], options },
      };
    });
  };

  submitEditQuestion = async () => {
    const { id } = this.props.match.params;
    const token = getAccessToken();
    const { editingQuestion } = this.state;

    try {
      const response = await Axios.patch(
        `${Constant.apiBasePath}registration-forms/edit-question/${id}/${editingQuestion._id}`,
        { updatedQuestion: editingQuestion },
        { headers: { token } }
      );
      if (response.data.message === "Question updated successfully") {
        alert("Question updated successfully!");
        this.fetchQuestions();
        this.setState({ editingQuestion: null });
      } else {
        alert(response.data.message);
      }
    } catch (err) {
      console.error("Error editing question:", err);
      alert("Failed to edit question. Please try again.");
    }
  };

  editQuestion = (question) => {
    this.setState({ editingQuestion: { ...question } });
  };

  cancelEdit = () => {
    this.setState({ editingQuestion: null });
  };

  deleteQuestion = async (questionId) => {
    const { id } = this.props.match.params;
    const token = getAccessToken();

    if (window.confirm("Are you sure you want to delete this question?")) {
      try {
        const response = await Axios.patch(
          `${Constant.apiBasePath}registration-forms/delete-question/${id}/${questionId}`,
          { headers: { token } }
        );
        if (response.data.message === "Question deleted successfully") {
          alert("Question deleted successfully!");
          this.fetchQuestions();
        } else {
          alert(response.data.message);
        }
      } catch (err) {
        console.error("Error deleting question:", err);
        alert("Failed to delete question. Please try again.");
      }
    }
  };

  submitNewQuestion = async () => {
    const { id } = this.props.match.params;
    const token = getAccessToken();
    const { newQuestion } = this.state;

    try {
      // Wrap the single question in an array to match API expectations
      const payload = {
        newQuestions: [newQuestion],
      };

      const response = await Axios.patch(
        // `http://localhost:8083/api/registration-forms/add-questions/${id}`,
        `${Constant.apiBasePath}registration-forms/add-questions/${id}`,
        payload,
        { headers: { token } }
      );
      if (response.data.message === "Questions added successfully") {
        alert("Question added successfully!");
        this.fetchQuestions();
        this.setState({
          newQuestion: {
            questionText: "",
            inputType: INPUT_TYPES.TEXT,
            options: [],
            isRequired: false,
            allowOther: false,
            imageUrl: "",
          },
          isAdding: false,
        });
      } else {
        alert(response.data.message);
      }
    } catch (err) {
      console.error("Error adding question:", err);
      alert("Failed to add question. Please try again.");
    }
  };

  handleImageUpload = async (e, isEditing = false) => {
    const file = e.target.files[0];
    if (!file) {
      alert("Please select a file to upload.");
      return;
    }

    const token = getAccessToken();
    const formData = new FormData();
    formData.append("formImage", file);

    this.setState({ uploadingImage: true });

    try {
      const response = await Axios.post(
        `${Constant.apiBasePath}registration-forms/uploadFormImageOnS3`,
        formData,
        {
          headers: {
            token,
            "Content-Type": "multipart/form-data",
          },
        }
      );

      if (response.data.status === "Success") {
        const uploadedImageUrl = response.data.location;
        const currentQuestion = isEditing ? "editingQuestion" : "newQuestion";

        this.setState((prevState) => ({
          [currentQuestion]: {
            ...prevState[currentQuestion],
            options: [uploadedImageUrl], // Store image URL in options array
            imageUrl: uploadedImageUrl, // Keep for UI display
          },
          uploadingImage: false,
        }));
        alert("Image uploaded successfully!");
      } else {
        alert(response.data.message || "Image upload failed.");
        this.setState({ uploadingImage: false });
      }
    } catch (err) {
      console.error("Error uploading image:", err);
      alert("Image upload failed. Please try again.");
      this.setState({ uploadingImage: false });
    }
  };

  componentDidMount() {
    this.fetchQuestions();
  }

  render() {
    const {
      questions,
      newQuestion,
      editingQuestion,
      loading,
      error,
      isAdding,
    } = this.state;
    const { id } = this.props.match.params;

    if (loading) return <div className="table-loading-cell">Loading...</div>;
    if (error) return <div className="table-loading-cell">Error: {error}</div>;

    return (
      <div className="content-page contest-submissions-page contest-management-page registration-questions-page event-consistent-page">
        <div className="content page-content-spaced">
          <div className="event-management-header">
            <div className="header-content">
              <div className="header-title">
                <h4 className="page-title-heading">Form Questions</h4>
                <p className="header-subtitle">
                  Add, edit, and manage registration form questions.
                </p>
              </div>
              <div className="header-actions">
                <Link to={`/edit-registration-form/${id}`} className="btn openmic-link-btn">
                  Edit Form
                </Link>
                <Link to="/registeration-form" className="btn openmic-link-btn">
                  Back to Forms
                </Link>
              </div>
            </div>
          </div>

          <div className="event-management-body">
              <div className="card contest-like-card">
                <div className="card-body">
                  {!editingQuestion && (
                    <button
                      className="btn btn-primary btn-add-event contest-add-match mb-3"
                      type="button"
                      onClick={() => {
                        this.setState({ isAdding: true });
                      }}
                    >
                      + Add Question
                    </button>
                  )}
                  {isAdding && (
                    <div className="mb-3">
                      <h5>Add New Question</h5>
                      <div>
                        <label>Question Text:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="questionText"
                          value={newQuestion.questionText}
                          onChange={this.handleInputChange}
                        />
                      </div>
                      <div>
                        <label>Input Type:</label>
                        <select
                          className="form-control"
                          name="inputType"
                          value={newQuestion.inputType}
                          onChange={this.handleInputChange}
                        >
                          {Object.values(INPUT_TYPES).map((type) => (
                            <option key={type} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                      </div>
                      {["radio", "checkbox", "select"].includes(
                        newQuestion.inputType
                      ) && (
                        <div>
                          <label>Options:</label>
                          {newQuestion.options.map((option, index) => (
                            <div key={index} className="d-flex mb-2">
                              <input
                                type="text"
                                className="form-control"
                                value={option}
                                onChange={(e) =>
                                  this.handleOptionChange(index, e.target.value)
                                }
                              />
                              <button
                                className="btn btn-danger ml-2"
                                type="button"
                                onClick={() => this.removeOption(index)}
                              >
                                Remove
                              </button>
                            </div>
                          ))}
                          <button
                            className="btn btn-secondary"
                            type="button"
                            onClick={() => this.addOption()}
                          >
                            Add Option
                          </button>
                        </div>
                      )}
                      {newQuestion.inputType === INPUT_TYPES.IMAGE && (
                        <div>
                          <label>Upload Image:</label>
                          <input
                            type="file"
                            className="form-control"
                            accept="image/*"
                            onChange={(e) => this.handleImageUpload(e, false)}
                            disabled={this.state.uploadingImage}
                          />
                          {this.state.uploadingImage && (
                            <div className="text-info">Uploading image...</div>
                          )}
                          {newQuestion.options &&
                            newQuestion.options.length > 0 && (
                              <div className="mt-2">
                                <img
                                  src={newQuestion.options[0]}
                                  alt="Uploaded"
                                  style={{
                                    maxWidth: "200px",
                                    maxHeight: "200px",
                                  }}
                                  className="img-thumbnail"
                                />
                              </div>
                            )}
                        </div>
                      )}
                      <div className="form-check mt-3">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name="isRequired"
                          checked={newQuestion.isRequired}
                          onChange={(e) =>
                            this.handleInputChange({
                              target: {
                                name: "isRequired",
                                value: e.target.checked,
                              },
                            })
                          }
                        />
                        <label className="form-check-label">Required</label>
                      </div>
                      <button
                        className="btn btn-success mt-3"
                        type="button"
                        onClick={this.submitNewQuestion}
                      >
                        Save
                      </button>
                      <button
                        className="btn btn-secondary mt-3 ml-2"
                        type="button"
                        onClick={() => this.setState({ isAdding: false })}
                      >
                        Cancel
                      </button>
                    </div>
                  )}
                  {editingQuestion ? (
                    <div className="mb-3">
                      <h5>Edit Question</h5>
                      <div>
                        <label>Question Text:</label>
                        <input
                          type="text"
                          className="form-control"
                          name="questionText"
                          value={editingQuestion.questionText}
                          onChange={this.handleInputChange}
                        />
                      </div>
                      <div>
                        <label>Input Type:</label>
                        <select
                          className="form-control"
                          name="inputType"
                          value={editingQuestion.inputType}
                          onChange={this.handleInputChange}
                        >
                          {Object.values(INPUT_TYPES).map((type) => (
                            <option key={type} value={type}>
                              {type}
                            </option>
                          ))}
                        </select>
                      </div>
                      {["radio", "checkbox", "select"].includes(
                        editingQuestion.inputType
                      ) && (
                        <div>
                          <label>Options:</label>
                          {editingQuestion.options.map((option, index) => (
                            <div key={index} className="d-flex mb-2">
                              <input
                                type="text"
                                className="form-control"
                                value={option}
                                onChange={(e) =>
                                  this.handleOptionChange(
                                    index,
                                    e.target.value,
                                    true
                                  )
                                }
                              />
                              <button
                                className="btn btn-danger ml-2"
                                type="button"
                                onClick={() => this.removeOption(index, true)}
                              >
                                Remove
                              </button>
                            </div>
                          ))}
                          <button
                            className="btn btn-secondary"
                            type="button"
                            onClick={() => this.addOption(true)}
                          >
                            Add Option
                          </button>
                        </div>
                      )}
                      {editingQuestion.inputType === INPUT_TYPES.IMAGE && (
                        <div>
                          <label>Upload Image:</label>
                          <input
                            type="file"
                            className="form-control"
                            accept="image/*"
                            onChange={(e) => this.handleImageUpload(e, true)}
                            disabled={this.state.uploadingImage}
                          />
                          {this.state.uploadingImage && (
                            <div className="text-info">Uploading image...</div>
                          )}
                          {editingQuestion.options &&
                            editingQuestion.options.length > 0 && (
                              <div className="mt-2">
                                <img
                                  src={editingQuestion.options[0]}
                                  alt="Uploaded"
                                  style={{
                                    maxWidth: "200px",
                                    maxHeight: "200px",
                                  }}
                                  className="img-thumbnail"
                                />
                              </div>
                            )}
                        </div>
                      )}
                      <div className="form-check mt-3">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          name="isRequired"
                          checked={editingQuestion.isRequired}
                          onChange={(e) =>
                            this.handleInputChange({
                              target: {
                                name: "isRequired",
                                value: e.target.checked,
                              },
                            })
                          }
                        />
                        <label className="form-check-label">Required</label>
                      </div>
                      <button
                        className="btn btn-success mt-3"
                        type="button"
                        onClick={this.submitEditQuestion}
                      >
                        Save
                      </button>
                      <button
                        className="btn btn-secondary mt-3 ml-2"
                        type="button"
                        onClick={this.cancelEdit}
                      >
                        Cancel
                      </button>
                    </div>
                  ) : (
                    ""
                  )}
                  {!editingQuestion && (
                    <div className="table-wrapper contest-submissions-table-responsive contest-like-table-responsive">
                      <table className="table event-table contest-submissions-table contest-like-table">
                        <thead>
                          <tr>
                            <th>Question</th>
                            <th>Input Type</th>
                            <th>Options/Image</th>
                            <th>Allow Other</th>
                            <th>Required</th>
                            <th className="actions-col">Actions</th>
                          </tr>
                        </thead>
                        <tbody>
                          {questions.map((q) => (
                            <tr key={q._id}>
                              <td>{q.questionText}</td>
                              <td>{q.inputType}</td>
                              <td>
                                {q.inputType === INPUT_TYPES.IMAGE ? (
                                  q.options && q.options.length > 0 ? (
                                    <img
                                      src={q.options[0]}
                                      alt="Question Image"
                                      style={{
                                        maxWidth: "100px",
                                        maxHeight: "100px",
                                      }}
                                      className="img-thumbnail"
                                    />
                                  ) : (
                                    "No image uploaded"
                                  )
                                ) : (
                                  q.options.join(", ") || "N/A"
                                )}
                              </td>
                              <td>{q.allowOther ? "Yes" : "No"}</td>
                              <td>{q.isRequired ? "Yes" : "No"}</td>
                              <td className="registration-question-actions">
                                <div className="registration-question-actions-wrap">
                                  <button
                                    className="contest-icon-btn"
                                    type="button"
                                    title="Edit"
                                    aria-label="Edit question"
                                    onClick={() => this.editQuestion(q)}
                                  >
                                    <FontAwesomeIcon icon={faEdit} style={{ fontSize: "13px" }} />
                                  </button>
                                  <button
                                    className="contest-icon-btn danger"
                                    type="button"
                                    title="Delete"
                                    aria-label="Delete question"
                                    onClick={() => this.deleteQuestion(q._id)}
                                  >
                                    <FontAwesomeIcon icon={faTrashAlt} style={{ fontSize: "13px" }} />
                                  </button>
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                </div>
              </div>
          </div>
        </div>
      </div>
    );
  }
}

export default FormQuestions;
